/* global $ */

__webpack_public_path__ = '/front_assets/'; // eslint-disable-line

/* eslint-disable import/first */
import './helpers/requestIdleCallback';
import './polyfills';
import general from './containers/general';

Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};

const token = document.head.querySelector('meta[name="csrf-token"]').content;

$.ajaxSetup({
  beforeSend: (xhr) => {
    xhr.setRequestHeader('X-CSRF-TOKEN', token);
  },
});

general();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(() => {
      // Registration was successful
    }, (err) => {
      // registration failed :(
      console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
    });
  });
}
